import { useState } from 'react';
import MeasurementUnits from '../../Layout/MeasurementUnits';
import { Collapse } from 'reactstrap';
import CookbookIngredientReplacementList from './CookbookIngredientReplacementList';
import { useAppContext } from '@front-activerse/common-components';

const CookbookIngredient = ({
  name,
  measurements,
  multiplier,
  isReplaceable,
  replacements,
  isReplaced,
  originalIngredient,
  dishId,
  id,
  mealId,
  ingredientKey,
}) => {
  const [collapse, setCollapse] = useState(false);

  const {
    images: { iconChange, iconChangeDone },
  } = useAppContext();

  const handleClick = () => {
    if ((isReplaceable && replacements.length > 0) || originalIngredient) {
      setCollapse(!collapse);
    }
  };

  return (
    <li
      onClick={() => handleClick()}
      style={
        (isReplaceable && replacements.length > 0) || originalIngredient
          ? { cursor: 'pointer' }
          : {}
      }
    >
      <MeasurementUnits measurements={measurements} multiplier={multiplier} />
      <span className="stay-together">
        {(isReplaceable && replacements.length > 0) || originalIngredient ? (
          <button
            type="button"
            className={
              collapse
                ? 'btn-change animate__animated rotateLeft'
                : 'btn-change animate__animated rotateRight'
            }
            data-test="exchange-button"
          >
            <img className="img-fluid" src={isReplaced ? iconChangeDone : iconChange} alt="" />
          </button>
        ) : (
          ''
        )}
      </span>
      {name}
      <Collapse isOpen={collapse}>
        <CookbookIngredientReplacementList
          isReplaced={isReplaced}
          replacements={replacements}
          originalIngredient={originalIngredient}
          multiplier={multiplier}
          dishId={dishId}
          ingredientId={id}
          mealId={mealId}
          ingredientKey={ingredientKey}
          closeCollapse={() => setCollapse(false)}
        />
      </Collapse>
      <div className="clearfix" />
    </li>
  );
};

export default CookbookIngredient;
